import React from 'react';
import { CheckIcon, PlusIcon } from 'lucide-react';
import { money } from '../QuantityStepper';
interface BuilderOptionCardProps {
  title: string;
  body?: string;
  price: number;
  selected: boolean;
  onToggle?: () => void;
  /** Included in the current configuration: shown as selected and not toggleable. */
  included?: boolean;
  role?: 'checkbox' | 'radio';
  media?: React.ReactNode;
  priceLabel?: string;
  children?: React.ReactNode;
}
export function BuilderOptionCard({
  title,
  body,
  price,
  selected,
  onToggle,
  included = false,
  role = 'checkbox',
  media,
  priceLabel,
  children
}: BuilderOptionCardProps) {
  const active = selected || included;
  const label = priceLabel ?? (included ? 'Included' : price === 0 ? 'Included' : `+${money(price)}`);
  return <button type="button" role={role} aria-checked={active} aria-disabled={included || undefined} onClick={included ? undefined : onToggle} className={`group flex w-full items-start gap-4 border-2 p-4 text-left transition-[border-color,background-color] duration-150 ease-grit focus:outline-none focus-visible:ring-2 focus-visible:ring-grit-500 sm:p-5 ${active ? 'border-grit-500 bg-grit-500/[0.07]' : 'border-white/12 bg-ink-950 hover:border-white/30'} ${included ? 'cursor-default' : ''}`} data-id="element-85" data-mp="3kktsz25vecte">
      {media && <span className="shrink-0" data-id="element-86" data-mp="3nkunhgxgzug8">{media}</span>}
      <span className="min-w-0 flex-1" data-id="element-87" data-mp="f49cjula2rah">
        <span className="flex items-start justify-between gap-3" data-id="element-88" data-mp="f5ayiu3u0y6z">
          <span className="font-display text-xl font-extrabold uppercase leading-tight text-offwhite sm:text-2xl" data-id="element-89" data-mp="k441vtpen8tf">{title}</span>
          <span className={`shrink-0 font-display text-lg font-extrabold leading-tight ${active ? 'text-grit-500' : 'text-offwhite'}`} data-id="element-90" data-mp="6bxxt5zj0sac">
            {label}
          </span>
        </span>
        {body && <span className="mt-1.5 block text-[14px] leading-relaxed text-steel-300" data-id="element-91" data-mp="y2u23i7itom0">{body}</span>}
        {children}
      </span>
      <span aria-hidden="true" className={`mt-1 flex h-6 w-6 shrink-0 items-center justify-center border-2 transition-colors duration-150 ease-grit ${role === 'radio' ? 'rounded-full' : ''} ${active ? 'border-grit-500 bg-grit-500 text-ink-950' : 'border-white/30 text-steel-400'}`} data-id="element-92" data-mp="12wgf5bhljuic">
        {active ? <CheckIcon className="h-4 w-4" strokeWidth={3} data-id="element-93" data-mp="yr2tboo9i385" /> : role === 'checkbox' ? <PlusIcon className="h-3.5 w-3.5" data-id="element-94" data-mp="ysxgl9n0a7fe" /> : null}
      </span>
    </button>;
}